import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import Tooltip from '../../Components/Interactive/Tooltip/Tooltip';
import { Size } from '../../Constants/System';
import { Typography } from '../../Constants/Typography';
export default function TruncateSpan(props) {
    const { tooltipProps, className, children, ...rest } = props;
    return (_jsx(Tooltip, { size: Size.small, placement: 'right', appendTo: document.body, hideOnClick: false, duration: 0, text: children, ...tooltipProps, children: _jsx(Content, { className: className, ...rest, children: children }) }));
}
const Content = styled.span `
	${Typography.Truncate}
`;
//# sourceMappingURL=TruncateSpan.js.map